import { Skeleton } from '@mui/material';
import {
  IconScubaMask,
  IconChevronLeft,
  IconChevronRight,
} from '@tabler/icons-react';

const BoatTripSkeleton = () => {
  return (
    <div className="mt-8">
      {/* Header */}
      <div className="flex flex-col items-start gap-2">
        <div className="flex items-center gap-2">
          <IconScubaMask size={24} />
          <Skeleton variant="text" width={200} height={32} />
        </div>
        <Skeleton variant="text" width="80%" height={24} />
      </div>

      {/* Month Selector */}
      <div className="mt-4 flex justify-center items-center gap-4 self-stretch">
        <button
          className="flex p-2 items-start gap-2 rounded-full border border-neutral-50 bg-white disabled:text-neutral-100"
          disabled
        >
          <IconChevronLeft size={20} />
        </button>
        <Skeleton variant="text" width={120} height={24} />
        <button
          className="flex p-2 items-start gap-2 rounded-full border border-neutral-50 bg-white"
          disabled
        >
          <IconChevronRight size={20} />
        </button>
      </div>

      {/* Trip List */}
      <div className="mt-4">
        {[1, 2, 3].map(item => (
          <div
            key={item}
            className="flex py-4 items-center gap-4 self-stretch border-b border-neutral-100 md:w-full"
          >
            {/* Mobile Version */}
            <div className="flex flex-col items-start gap-2 flex-grow flex-shrink-0 md:hidden w-full">
              <Skeleton variant="text" width="60%" height={24} />
              <Skeleton variant="text" width="50%" height={24} />
              <div className="flex items-center content-start gap-[0.5rem] self-stretch flex-wrap">
                <Skeleton variant="rectangular" width={80} height={20} />
                <Skeleton variant="rectangular" width={80} height={20} />
                <Skeleton variant="rectangular" width={80} height={20} />
              </div>
              <Skeleton variant="text" width={100} height={20} />
            </div>
            {/* Price and Arrow */}
            <div className="flex flex-col justify-center items-end gap-2 md:hidden">
              <Skeleton variant="text" width={80} height={24} />
              <div className="invisible"></div>
            </div>

            {/* Desktop Version */}
            <div className="hidden md:flex items-center gap-6 self-stretch w-full">
              <div className="flex items-start flex-grow">
                {/* Date and Duration */}
                <div className="flex w-36 py-4 pr-2 flex-col items-start gap-2">
                  <Skeleton variant="text" width="80%" height={24} />
                  <div className="flex items-start gap-2">
                    <Skeleton variant="rectangular" width={60} height={20} />
                    <Skeleton variant="rectangular" width={60} height={20} />
                  </div>
                </div>
                {/* Trip Details */}
                <div className="flex py-4 px-2 items-center gap-2 flex-grow">
                  <div className="flex flex-col items-start gap-2">
                    <Skeleton variant="text" width="70%" height={24} />
                    <div className="flex items-center gap-4">
                      <Skeleton variant="rectangular" width={100} height={20} />
                      <Skeleton variant="text" width={80} height={20} />
                    </div>
                  </div>
                </div>
                {/* Price */}
                <div className="flex py-4 px-2 flex-col justify-center items-end gap-2">
                  <Skeleton variant="text" width={80} height={24} />
                </div>
              </div>
              <div className="hidden md:flex">
                <IconChevronRight size={20} />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BoatTripSkeleton;
